/**
 * @author xyguo 2020-9-10
 * 查看证书信息
 */
import React from "react";
import { connect } from "dva";
import "@/styles/containers/personManage/personInfoDetail/index.less";
import { component_tool, framework_tool, utils_tool } from "../../../../tool";
let { Session ,dateUtils} = utils_tool
let { ossFileUtils } = framework_tool;

let {
  WizCard,
  WizRow,
  WizCol,
  WizSurveyAudience,
  WizTabs,
  WizModal,
} = component_tool;
let { WizContainer } = framework_tool;

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
      if (history.location.pathname === '/personalCert/personalCertList/personalCertInfo') {
          if (history.location && history.location.record) {
              record = history.location.record
              Session.set('personalCertInfo', record)
          } else {
              record = Session.get('personalCertInfo') || {}
          }
      }
  }
  return record
}

class PersonalCertInfo extends WizContainer {
  componentName = "PersonalCertInfo";
  constructor(props) {
    super(props);
    this.state = {
      record: getParamRecord(props.history),
      previewImgVisible: false,
      previewImgKey: new Date().getTime(),
      previewImage: '',
  }
  }

  _renderTitleInfoRow(leftName, leftValue = '', rightName, rightValue = '') {
    return (
      <WizRow className='text_row'>
        <WizCol className='text_right' span={3} offset={0.5}>{leftName + '：'}</WizCol>
        <WizCol span={6}>{leftValue}</WizCol>
        <WizCol className='text_right' span={3} offset={2}>{rightName + '：'}</WizCol>
        <WizCol span={6}>{rightValue}</WizCol>
      </WizRow>
    )
  }

  _renderTitleInfoRowAll(leftName, leftValue = '') {
    return (
      <WizRow className='text_row'>
        <WizCol className='text_right' span={3} offset={0.5}>{leftName + '：'}</WizCol>
        <WizCol span={6}>{leftValue}</WizCol>
      </WizRow>
    )
  }

  _renderTitleInfoRowImg(leftName, leftValue = '', rightName, rightValue = '') {
    return (
      <WizRow className='text_row'>
        <WizCol className='text_right' span={3} offset={0.5}>{leftName + '：'}</WizCol>
        <WizCol span={6}>
          {leftValue? <img height={180} width={270} src={leftValue} onClick={p => this.handlePreview(leftValue)}/> : null}
        </WizCol>
        <WizCol className='text_right' span={3} offset={2}>{rightName + '：'}</WizCol>
        <WizCol span={6}>
          {rightValue? <img height={180} width={270} src={rightValue} onClick={p => this.handlePreview(rightValue)}/>:null}
        </WizCol>
      </WizRow>
    )
  }

  /** 打开图片查看*/
  handlePreview = async element => {
    this.setState({
      previewImage: element,
      previewImgVisible: true,
      previewImgKey: new Date().getTime(),
    });
  };

  /** 关闭查看Model*/
  handleCancel = () => this.setState({
    previewImgVisible: false
  });

  _render() {
   const info = this.state.record;
   if (info['userType'] === 0) {
    info['userType'] = "培训平台用户"
  } else if (info['userType'] === 3) {
    info['userType'] = "OEM部门用户"
  } else if (info['userType'] === 4) {
    info['userType'] = "经销商用户"
  } else if (info['userType'] === 5) {
    info['userType'] = "服务商用户"
  // } else if (info['userType'] === 5) {
  //   info['userType'] = "FSE"
  } else {
    info['userType'] = ""
  }

    return (

      <>
        <WizCard title={'人员基本信息'}>
          {this._renderTitleInfoRow('账号', info.userName, '姓名', info.fullName)}
          {this._renderTitleInfoRow('邮箱', info.email, '用户属性', info.userType)}
          {this._renderTitleInfoRow('性别', info.gender===2 ? "未知":info.gender===1 ? "女":"男" , '手机号', info.mobile)}
          {this._renderTitleInfoRowAll('账号状态', info.userState === 1 ? '激活' : '禁用',null)}
        </WizCard>
        <WizCard title={'证书信息'}>
          {info.certType === 1 ?
          <>{this._renderTitleInfoRow('证书名称', info.certName, '证书状态', info.state===1 ? "有效" : "无效")}
          {this._renderTitleInfoRow('证书类型', info.classify === 1 ?'个人':'店端', '证书类别', info.certType === 1 ? '培训证书' :'社会证书')}
          {this._renderTitleInfoRow('证书编码', info.certCode , '获取途径', info.channel)}
          {this._renderTitleInfoRowAll('证书获取时间', dateUtils.formatDateString(info.certDate, 'yyyy-MM-dd'))} </>
          :
          <>{this._renderTitleInfoRow('证书名称', info.certName, '证书状态', info.state===1 ? "有效" : "无效")}
          {this._renderTitleInfoRow('证书类型', info.classify === 1 ?'个人':'店端', '证书类别', info.certType === 1 ? '培训证书' :'社会证书')}
          {this._renderTitleInfoRow('证书编码', info.certCode , '颁发单位', info.certDetail.awardUnit)}
          {this._renderTitleInfoRow('有效开始日期', dateUtils.formatDateString(info.certDetail.startDate,'yyyy-MM-dd') , '有效结束日期', dateUtils.formatDateString(info.certDetail.endDate,'yyyy-MM-dd') )}
          {this._renderTitleInfoRow('复审日期', dateUtils.formatDateString(info.certDetail.reCheckDate,'yyyy-MM-dd')  , '初领日期', dateUtils.formatDateString(info.certDetail.firstDate,'yyyy-MM-dd') )}
          {this._renderTitleInfoRowImg(
            '证书照片（主）', info.certDetail.imgMain ?
            // ossFileUtils.getOssFile(
            //   info.certDetail.imgMain,
            //   info.certDetail.fileNameMain,
            //   info.certDetail.fileMimeTypeMain,
            //   info.certDetail.fileSizeMain,
            //   info.certDetail.fileUriMain,
            // )['thumbUrl']
            getOssFilePath(info.certDetail.imgMain)
            :constants.files.sys_img_loadingFailed,
           '证书照片（副）', info.certDetail.imgSecondary ?
          //  ossFileUtils.getOssFile(
          //   info.certDetail.imgSecondary,
          //   info.certDetail.fileNameSecondary,
          //   info.certDetail.fileMimeTypeSecondary,
          //   info.certDetail.fileSizeSecondary,
          //   info.certDetail.fileUriSecondary,
          // )['thumbUrl']
          getOssFilePath(info.certDetail.imgSecondary)
          :constants.files.sys_img_loadingFailed,
           )}
          </>

          }

        </WizCard>
        <WizModal key={'img_preview_' + this.state.previewImgKey} visible={this.state.previewImgVisible} footer={null}
                    onCancel={this.handleCancel}>
            <img alt="example" style={{width: '100%'}} src={this.state.previewImage}/>
          </WizModal>
      </>
    )
  }

  getIdCardStr = (userType) => {
    // if (userType === '总部' || userType === '区域'
    //   // || userType === 'FSE'
    // ) {
    //   return '工号'
    // }
    return '证件号码'
  }

}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(PersonalCertInfo);
